import { useEffect, useState } from "react";
export function useScrollPosition() {
  const [position, setPosition] = useState(0);
  const onScroll = () => setPosition(Math.round(window.scrollY));
  useEffect(() => {
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return position;
}